import { render, staticRenderFns } from "./yanghudanwei.vue?vue&type=template&id=2cfbfcae&scoped=true&"
import script from "./yanghudanwei.vue?vue&type=script&lang=js&"
export * from "./yanghudanwei.vue?vue&type=script&lang=js&"
import style0 from "./yanghudanwei.vue?vue&type=style&index=0&id=2cfbfcae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbfcae",
  null
  
)

export default component.exports